import { Skeleton } from '@mui/material';

function FileUploadTitleLoader(): JSX.Element {
  return <Skeleton width={'40%'} variant={'text'} />;
}

export default FileUploadTitleLoader;
